import { generateURL } from '../utils/helper';
import { session } from '../Service/APIService';

async function RefreshToken() {
  const userObj = session.user();
  const details = {
    username: userObj.email,
    password: '',
    feui: '#####',
    ref: 10111011,
  };
  let formBody = [];

  Object.keys(details).forEach((key) => {
    formBody.push(`${key}=${encodeURIComponent(details[key])}`);
  });

  formBody = formBody.join('&');
  const GENERIC_URL = generateURL();
  const resp = await fetch(`${GENERIC_URL}/token`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
    },
    body: formBody,
  });
  const data = await resp.json();
  if (data.statusCode === undefined) {
    userObj.token = data.token;
    userObj.aliveTill = data.aliveTill;
    session.setUser(userObj);
    return true;
  }
  return false;
}

export default RefreshToken;
